import { getCurrentLocaleCode } from "@mongez/localization";
import { Filter } from "core/catalog";
import { SliderRangeInput } from "~/design-system/components/form/SliderRangeInput";
import { usePriceFilter } from "../../hooks";

export function PriceFilter({ filter }: { filter: Filter }) {
  const currentLocaleCode = getCurrentLocaleCode();

  const { data, debouncedUpdateFilter, setValues, values } =
    usePriceFilter(filter);

  return (
    <div className="px-2 py-6 font-semibold">
      <SliderRangeInput
        name=""
        className="range-slider"
        value={values}
        onChange={(newValues: [number, number]) => {
          setValues(newValues);
          debouncedUpdateFilter(newValues);
        }}
        min={data.min}
        step={1}
        max={data.max}
        minDistance={10}
        invert={currentLocaleCode === "ar"}
        renderThumb={(
          {
            key,
            ...props
          }: React.HTMLAttributes<HTMLDivElement> & { key: string },
          state: { index: number; valueNow: number },
        ) => (
          <div key={key} {...props}>
            <p
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                top: state.index === 1 ? "-1.5rem" : "1rem",
                whiteSpace: "nowrap",
              }}
            >
              {state.valueNow}
            </p>
          </div>
        )}
      />
    </div>
  );
}
